import { useState } from "react";
import { dispatch, getState } from "../../state/store";
import { selectNotificationCampaignToEdit } from "../../state/selectors";
import {
  setNotificationCampaignsRefresh,
  setNotificationCampaignToEdit
} from "../../state/ducks";

import { campaignStatus, strCode } from "../../consts";
import { log, notificationCampaignsService, notificationService, t } from "../../services";
import { responseUtil } from "../../utils";

export const useDeactivateNotificationCampaign = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  // TODO: temporary hotfix
  const refreshNotificationCampaignToEdit = () => {
    const notificationCampaignToEdit = selectNotificationCampaignToEdit()(getState());

    if (notificationCampaignToEdit) {
      notificationCampaignToEdit.status = campaignStatus.deactivated;

      dispatch(setNotificationCampaignToEdit(notificationCampaignToEdit));
    }
  };

  const mutationCallback = async (campaignName) => {
    setLoading(true);
    setError(false);

    try {
      const res = await notificationCampaignsService.deactivateCampaign(campaignName);

      if (responseUtil.isResponseSuccessful(res)) {
        notificationService.showSuccess({
          title: t(strCode.DEACTIVATE_NOTIFICATION_CAMPAIGN_SUCCESS),
          message: t(strCode.DEACTIVATE_NOTIFICATION_CAMPAIGN_SUCCESS_INFO, {
            name: campaignName
          })
        });

        refreshNotificationCampaignToEdit();
        dispatch(setNotificationCampaignsRefresh(true));
      }
    } catch (err) {
      setError(true);

      log.error(
        "useDeactivateNotificationCampaign: Failed to deactivate notification campaign",
        err
      );

      notificationService.showError({
        title: t(strCode.DEACTIVATE_NOTIFICATION_CAMPAIGN_ERROR),
        message: err?.response?.data ? err.response.data : err?.toString()
      });
    } finally {
      setLoading(false);
    }
  };

  return { mutationCallback, loading, error };
};
